export const formatGrade = (grade: unknown): string => {
    if (typeof grade !== "number" || !Number.isFinite(grade)) {
        return grade === null || grade === undefined ? "" : String(grade)
    }

    return Number.isInteger(grade) ? String(grade) : grade.toFixed(2)
}
